export default "__VITE_ASSET__TQob3EpN__"